export enum PRODUCT_TYPE {
  STOCKABLE = "STOCKABLE",
  NON_STOCKABLE = "NON STOCKABLE",
  SERVICE = "SERVICE",
  GENERAL = "GENERAL",
}
